<template>
  <div>
    <ListSearchToobar v-model="searchRquest" v-bind="searchToobarData" @search="init" ref="topBar" />
    <el-table id="test" :height="tableHeight" @row-dblclick="dblclickAction" highlight-current-row :data="tableData" style="width: 100%"
    v-loading="loading" v-dynamicLoading="{fn: getAdminListData}" header-row-class-name="highlight-last" cell-class-name="gray-back">
      <el-table-column width="30"></el-table-column>
      <el-table-column type="index" width="80" :label="$t('pos')"></el-table-column>
      <el-table-column prop="no" :label="$t('order_no')" width="200"></el-table-column>
      <!-- <el-table-column prop="createdTime" :label="$t('created_date')" width="130" :formatter="createdFormat" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="buyer" :label="$t('buyer')" width="160" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="company" :label="$t('company')" width="160" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="instCounts" :label="$t('instCount')"  width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="payableAmount" :formatter="AmountFormat" width="140" :label="$t('amount')" show-overflow-tooltip></el-table-column>
      <el-table-column prop="userNumber" :label="$t('user_qty')" width="140" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productName" :label="$t('product')" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="paymentDate" :label="$t('payment_date')" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="activeDate" :label="$t('active_date')" width="130" :formatter="activedFormat" show-overflow-tooltip></el-table-column>
      <el-table-column prop="monthNumber" :label="$t('subscribe_mon')" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="deadline" :label="$t('expire_date')" width="120" :formatter="deadlineFormat" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" :label="$t('order_status')"  width="135" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status === 10">{{ $t('submitted') }}</span>
          <span v-if="scope.row.status === 20">{{ $t('canceled') }}</span>
          <span v-if="scope.row.status === 30">{{ $t('completed') }}</span>
          <span v-if="scope.row.status === 40">{{ $t('apply_trial') }}</span>
          <span v-if="scope.row.status === 50">{{ $t('on_trial') }}</span>
          <span v-if="scope.row.status === 80">{{ $t('trial_reject') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="paymentStatus" :label="$t('status')" width="100" :formatter="paymentFormat" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="paymentStatus" :label="$t('pay_status')"  width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.payableAmount === 0"></span>
          <span v-else>
            <span v-if="scope.row.paymentStatus === 10">{{ $t('unpaid') }}</span>
            <span v-if="scope.row.paymentStatus === 20">{{ $t('paid') }}</span>
            <span v-if="scope.row.paymentStatus === 30">{{ $t('refunded') }}</span>
          </span>
        </template>
      </el-table-column> -->
      <el-table-column prop="operation" :label="$t('operation')" width="110">
        <template slot-scope="scope">
          <el-tooltip :content="$t('edit')" placement="top" effect="light">
            <span class="icon" v-show="scope.row.status  === 10" @click="ModifyClick(scope.row)"><i class="icon-color common-icon icon-modify"></i></span>
          </el-tooltip>
          <el-tooltip :content="$t('application_approved')" placement="top" effect="light">
            <span class="icon" v-show="scope.row.status  === 40" @click="applyApprovedClick(scope.row)"><i class="icon-color el-icon-circle-check" style="scale:1.3;display:flex;padding-top:3px;"></i></span>
          </el-tooltip>
           <el-tooltip :content="$t('application_reject')" placement="top" effect="light">
            <span class="icon" v-show="scope.row.status  === 40" @click="applyRejectClick(scope.row)"><i class="icon-color el-icon-remove-outline" style="scale:1.3;display:flex;padding-top:3px;"></i></span>
          </el-tooltip>
          <!-- <span class="icon" v-show="scope.row.status !== 20" @click="CancelClick(scope.row)"><i class="icon-color common-icon icon-close"></i></span> -->
        </template>
      </el-table-column>
    </el-table>
    <Footerbar ref="foot">
      <TotalNum v-bind="totalOptions" :totalData="totalNumber" ref="totalNum" slot="right" />
    </Footerbar>
    <el-dialog :visible.sync="dialogVisible" width="80%" custom-class="dialog-class" :close-on-click-modal="false" destroy-on-close :before-close="handleClose">
      <div slot="title" class="top-title">
        {{showBut ? ReadTitle : ModiflyTitle }}{{rowVal.no}}
      </div>
      <formPage ref="formpage" v-if="dialogVisible" @submit="submitOrder" :rowVal="rowVal" :listData="listData" :readModel="readModel" />
      <span slot="footer" class="dialog-footer">
        <el-button v-show="rowVal.status === 10" v-if="showBut" type="default" size="mini" round @click="handleModifyClick" style="width: 200px">{{ $t('modify') }}</el-button>
        <!-- <el-button v-show="rowVal.status !== 20" v-if="showBut" type="default" round @click="handleCloseClick" style="width: 200px">Close</el-button> -->
        <el-button v-show="rowVal.status !== 20" v-if="!showBut" type="primary" size="mini" round @click="handleOkClick" style="width: 200px">{{ $t('submit') }}</el-button>
        <el-button v-show="rowVal.status !== 20 && rowVal.status !== 30" type="default" size="mini" round @click="handleCancelClick" style="width: 200px">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TotalNum from '@/components/TotalNum';
import dynamicLoading from '@/directive/dynamicLoading/index.js';
import ListSearchToobar from '@/components/ListSearchToobar';
import Footerbar from '@/components/Footerbar';
import orderApi from '@/apis/order';
import formPage from './formPage';
import dateUtil from 'iceqerp-common/date-util';

export default {
  name: 'OrderList',
  data() {
    return {
      searchToobarData: {
        showBarRight: true,
        floatRight: true,
        formArray: [
          {
            label: this.$t('order_no'),
            type: 'input',
            model: 'orderNo',
            width: false
          },
          // {
          //   label: this.$t('created_date'),
          //   model: 'createdDate',
          //   type: 'dateTimePicker',
          //   width: true
          // },
          {
            label: this.$t('buyer'),
            type: 'input',
            model: 'buyer',
            width: false
          },
          {
            label: this.$t('telephone'),
            type: 'input',
            model: 'telphone',
            width: false
          },
          {
            label: this.$t('status'),
            type: 'select',
            model: 'status',
            width: false,
            options: [
              {
                value: '10',
                label: this.$t('unpaid')
              },
              {
                value: '20',
                label: this.$t('paid')
              },
              {
                value: '30',
                label: this.$t('refunded')
              }
            ]
          }
        ],
        iconName: 'icon-order',
        componentName: this.$t('order_list')
      },
      tableData: [],
      totalNumber: 0,
      pageIndex: 1,
      loading: false,
      dialogVisible: false,
      rowVal: {},
      searchRquest: {
        orderNo: '',
        buyer: '',
        phone: '',
        createdDate: '',
        beginCreatedTime: '',
        endCreatedTime: '',
        status: ''
      },
      tableHeight: 0,
      totalOptions: {
        flag: false,
        whiteTheme: true,
        type: 'Orders'
      },
      ModiflyTitle: this.$t('modify_order_'),
      ReadTitle: this.$t('order_'),
      listData: [],
      readModel: false,
      showBut: false
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    refreshHeight() {
      // console.log(
      //   '123',
      //   window.innerHeight,
      //   this.$refs.topBar.$el.offsetHeight,
      //   this.$refs.foot.$el.offsetHeight
      // );
      setTimeout(() => {
        const navBarHeight = 80;
        const tabHeight = 10;
        this.tableHeight =
          window.innerHeight -
          navBarHeight -
          tabHeight -
          this.$refs.topBar.$el.offsetHeight -
          this.$refs.foot.$el.offsetHeight + 1;
      }, 100);
    },
    async init() {
      this.refreshHeight();
      this.pageIndex = 1;
      if (
        this.searchRquest.createdDate === '' ||
        this.searchRquest.createdDate === null
      ) {
        this.searchRquest.beginCreatedTime = '';
        this.searchRquest.endCreatedTime = '';
      } else {
        const beginCreatedTime = dateUtil.getUtcBeginEndTimeStringOfDay(
          this.searchRquest.createdDate
        );
        this.searchRquest.beginCreatedTime = beginCreatedTime.beginTime;
        this.searchRquest.endCreatedTime = beginCreatedTime.endTime;
      }
      const req = {
        filter: {
          ...this.searchRquest
        }
      };
      this.totalNumber = 0;
      const res = await orderApi.adminOrderCount(req);
      this.totalNumber = res.totalNumber;
      this.tableData = [];
      this.getAdminListData();
    },

    async getAdminListData() {
      // console.log('getAdminListData', this.searchRquest);
      if (this.loading || this.tableData.length >= this.totalNumber) {
        return;
      }
      this.loading = true;
      const req = {
        filter: {
          ...this.searchRquest
        },
        pageIndex: this.pageIndex,
        pageSize: 50
      };
      const res = await orderApi.adminOrderList(req);
      // console.log('orderList', res);
      this.listData = res.list;
      this.tableData.push.apply(this.tableData, res.list);
      this.pageIndex++;
      this.loading = false;
    },

    ModifyClick(row) {
      this.dialogVisible = true;
      this.showBut = false;
      this.readModel = false;
      this.rowVal = { ...row };
    },

    async CancelClick(row) {
      const req = {
        id: row.no
      };
      const res = await orderApi.adminOrderCancel(req);
      if (res.reason) {
        this.$message({
          // message: '状态不符',
          message: this.$t('status_discrepancy'),
          type: 'error',
          duration: 5000,
          offset: 80
        });
      } else {
        this.init();
        this.$message({
          // message: '成功',
          message: this.$t('success'),
          type: 'success',
          duration: 5000,
          offset: 80
        });
      }
      // console.log(res);
    },
    async applyApprovedClick(row) {
      this.loading = true;
      const req = {
        no: row.no
      };
      const res = await orderApi.approvedTrial(req);
      if (res.succeeded) {
        this.init();
        this.$message({
          message: this.$t('trial_orders_requested_success'),
          type: 'success',
          duration: 5000
        });
      } else if (res.reason === 1003) {
        this.$message({
          message: this.$t('status_discrepancy'),
          type: 'error',
          duration: 5000
        });
      } else if (res.reason === 1004) {
        this.$message({
          message: this.$t('trial_orders_have_been_requested'),
          type: 'error',
          duration: 5000
        });
      }
      this.loading = false;
    },

    async applyRejectClick(row) {
      this.loading = true;
      const req = {
        no: row.no
      };
      const res = await orderApi.rejectTrial(req);
      if (res.succeeded) {
        this.init();
        this.$message({
          message: this.$t('trial_orders_requested_reject'),
          type: 'success',
          duration: 5000
        });
      }
      this.loading = false;
    },

    submitOrder() {
      this.init();
      this.dialogVisible = false;
    },

    typeFormat(row, column) {
      if (row.type === 10) {
        return 'Purchase';
      } else if (row.type === 20) {
        return 'Renewals and Upgrades';
      }
    },

    AmountFormat(row) {
      return row.payableAmount + ' ' + row.currency;
    },

    createdFormat(row) {
      if ('createdTime' in row) {
        return row.createdTime.split(' ')[0];
      }
    },

    activedFormat(row) {
      if ('activeDate' in row) {
        return row.activeDate.split(' ')[0];
      }
    },

    deadlineFormat(row) {
      if ('deadline' in row) {
        return row.deadline.split(' ')[0];
      }
    },

    paymentFormat(row) {
      if (row.payableAmount === 0) {
        return ' ';
      } else if (row.paymentStatus === 10 && (row.status === 40 || row.status === 50 || row.status === 80)) {
        return ' ';
      } else if (row.paymentStatus === 10) {
        return this.$t('unpaid');
      } else if (row.paymentStatus === 20) {
        return this.$t('paid');
      } else if (row.paymentStatus === 30) {
        return this.$t('refunded');
      }
    },

    handleCancelClick() {
      this.dialogVisible = false;
    },

    async handleOkClick() {
      this.$refs.formpage.$refs.form.validate((valid) => {
        if (valid) {
          this.ModifyPayable();
        } else {
          return false;
        }
      });
      this.dialogVisible = false;
    },

    async ModifyPayable() {
      const req = {
        id: this.rowVal.no,
        currency: this.rowVal.currency,
        payableAmount: this.rowVal.payableAmount
      };
      // console.log(req);
      const res = await orderApi.adminModifyPayable(req);
      // console.log(res);
      if (res.reason) {
        this.$message({
          message: this.$t('error'),
          type: 'error',
          duration: 5000,
          offset: 80
        });
      } else {
        this.init();
        this.$message({
          // message: '成功',
          message: this.$t('success'),
          type: 'success',
          duration: 5000,
          offset: 80
        });
      }
      this.dialogVisible = false;
    },

    dblclickAction(data) {
      this.dialogVisible = true;
      this.readModel = true;
      this.showBut = true;
      this.rowVal = { ...data };
    },

    handleModifyClick() {
      this.readModel = false;
      this.showBut = false;
    },

    async handleCloseClick() {
      // console.log(this.rowVal);
      const req = {
        id: this.rowVal.no
      };
      const res = await orderApi.adminOrderCancel(req);
      if (res.reason) {
        this.$message({
          // message: '状态不符',
          message: this.$t('status_discrepancy'),
          type: 'error',
          duration: 5000,
          offset: 80
        });
      } else {
        this.$message({
          // message: '成功',
          message: this.$t('success'),
          type: 'success',
          duration: 5000,
          offset: 80
        });
        this.dialogVisible = false;
        this.init();
      }
      // console.log(res);
    },

    handleClose(done) {
      if (!this.readModel) {
        // this.$confirm('确认关闭？')
        this.$confirm(this.$t('sure_to_close'))
          .then((_) => {
            done();
          })
          .catch((_) => {});
      } else {
        this.closeDialog();
      }
    },

    closeDialog() {
      this.dialogVisible = false;
    }
  },

  directives: { dynamicLoading },

  components: {
    ListSearchToobar,
    Footerbar,
    TotalNum,
    formPage
  }
};
</script>

<style lang="scss">
.el-tooltip__popper {
  color: #000 !important;
  max-width: 50%;
  background: #FFF !important;
  border: 1px  solid #000 !important;
  line-height: 1 !important;
  margin-bottom: 0px !important;
}
.el-tooltip__popper .popper__arrow:after {
  border-top-color: #FFF !important;
}
</style>
<style lang="scss">
.top-title {
  font-size: 24px;
  font-weight: 700;
  text-align: left;
  color: #292929;
}

.el-dialog__footer {
  padding-top: 20px;
  background: #f4f4f4;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  text-align: center;
}
</style>